import { render, staticRenderFns } from "./payment-detail.vue?vue&type=template&id=761ef178&scoped=true"
import script from "./payment-detail.vue?vue&type=script&lang=js"
export * from "./payment-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761ef178",
  null
  
)

export default component.exports